var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgType = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 20,
  fill: "none",
  viewBox: "0 0 20 20"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M5.801 2.262h8.398c.36 0 .683 0 .953.018.287.02.59.064.896.19.67.278 1.204.811 1.482 1.482.126.306.17.61.19.897.018.269.018.591.018.952v.032a1.071 1.071 0 0 1-2.143 0c0-.403 0-.651-.013-.839a.8.8 0 0 0-.032-.222.6.6 0 0 0-.322-.322.8.8 0 0 0-.222-.032 14 14 0 0 0-.84-.013h-3.094v11.19H12.5a1.071 1.071 0 0 1 0 2.143h-5a1.071 1.071 0 0 1 0-2.143h1.43V4.405H5.833c-.403 0-.651 0-.839.013a.8.8 0 0 0-.222.032.6.6 0 0 0-.322.322c0 .002-.02.047-.032.222-.013.188-.013.436-.013.84a1.071 1.071 0 1 1-2.143 0V5.8c0-.36 0-.683.018-.952.02-.287.064-.591.19-.897a2.742 2.742 0 0 1 1.482-1.482c.306-.126.61-.17.897-.19.269-.018.591-.018.952-.018",
  clipRule: "evenodd"
})));
SvgType.displayName = "SvgType";
export { SvgType as ReactComponent };
export default SvgType;